import React, { useEffect, useState, lazy } from 'react';
import { ArrowDownIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a2pN1LyEbKWK4erQvJURoS/Generated_Image_October_18%2C_2025_-_11_27PM_%281%29.png',
    alt: 'Todos los productos incluidos - Kit completo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nCiSC9aUsRunmUnfyyppQH/Gemini_Generated_Image_22k4qg22k4qg22k4.png',
    alt: 'Autocuidado en el Postparto - Ambiente acogedor'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/isdZx8EadPVkGpNXKkNPE2/10_minutos_para_volver_a_ti.png',
    alt: '10 minutos para volver a ti'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uKUnuV5H2pJZoBUkg3shdp/Diario.png',
    alt: 'Diario de Emociones Postparto'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rM6AjkJRxpgyvyj8gFjY6C/Plan_de_recuperacion.png',
    alt: 'Plan de recuperación del cuerpo postparto'
  }];
  const nextSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const prevSlide = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 4000);
    return () => clearInterval(interval);
  }, [currentIndex]);
  return <section className="w-full bg-gradient-to-b from-[#f8f2ee] to-[#faf7f5] pt-8 pb-10 px-3" data-id="element-134">
      <div className="max-w-5xl mx-auto" data-id="element-135">
        <div className="flex flex-col lg:flex-row items-center gap-5 lg:gap-10" data-id="element-136">
          <div className="w-full lg:w-1/2 space-y-3" data-id="element-137">
            <div data-id="element-138">
              <h1 className="text-3xl md:text-4xl font-serif font-medium text-[#444] leading-tight" data-id="element-139">
                Kit de Cuidado en el Postparto
              </h1>
            </div>
            <h2 className="text-lg md:text-xl text-[#8e7f7a] font-light" data-id="element-140">
              Cómo prepararte para el cuarto trimestre
            </h2>
            <div className="h-px w-24 bg-[#d4b7a8]" data-id="element-141"></div>
            <p className="text-base text-[#5a5553]" data-id="element-142">
              ¿Te perdiste un poco desde que nació tu bebé?
            </p>
            <p className="text-[#5a5553] text-sm md:text-base" data-id="element-143">
              No es solo cansancio. No es solo falta de sueño. Es algo más
              profundo. Más silencioso. Más real.
            </p>
            <p className="text-[#5a5553] italic text-sm md:text-base" data-id="element-144">
              Nadie te advirtió… Que el verdadero parto empieza después. Cuando
              todo el mundo desaparece, y tú… también.
            </p>
            <div className="pt-2" data-id="element-145">
              <a href="https://mamaplena.com/cart/58296384749649:1" className="inline-block bg-[#c08676] hover:bg-[#a86256] text-white font-medium py-1.5 px-4 rounded-md transition-all shadow-sm text-sm" target="_blank" rel="noopener noreferrer" data-id="element-146">
                Obtener Kit
              </a>
              <div className="flex items-center gap-2 mt-2 text-[#8e7f7a] text-sm" data-id="element-147">
                <ArrowDownIcon size={14} data-id="element-148" />
                <span data-id="element-149">Descubre más abajo</span>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 flex justify-center mt-3 lg:mt-0" data-id="element-150">
            <div className="relative w-full max-w-md aspect-[3/4]" data-id="element-151">
              <div className="overflow-hidden rounded-lg shadow-lg h-full" data-id="element-152">
                {images.map((image, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${index === currentIndex ? 'opacity-100 z-10' : 'opacity-0 z-0'}`} data-id="element-153">
                    <img src={image.src} alt={image.alt} className="w-full h-full object-cover" loading={index === 0 ? 'eager' : 'lazy'} fetchpriority={index === 0 ? 'high' : 'auto'} data-id="element-154" />
                  </div>)}
              </div>
              <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 z-20 bg-white/80 p-2 rounded-full shadow-md hover:bg-white transition-colors" aria-label="Anterior imagen" data-id="element-155">
                <ChevronLeftIcon size={20} className="text-[#8e7f7a]" data-id="element-156" />
              </button>
              <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 z-20 bg-white/80 p-2 rounded-full shadow-md hover:bg-white transition-colors" aria-label="Siguiente imagen" data-id="element-157">
                <ChevronRightIcon size={20} className="text-[#8e7f7a]" data-id="element-158" />
              </button>
              <div className="absolute bottom-3 left-0 right-0 z-20 flex justify-center gap-2" data-id="element-159">
                {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-[#d4b7a8] w-4' : 'bg-white/70'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-160" />)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};